import React from "react";
import { withAllContexts } from "../../AllContextsWrapper";
import {
  CalendarViewWeekOutlined as CalendarViewWeekOutlinedIcon,
  CalendarViewMonthOutlined as CalendarViewMonthOutlinedIcon,
  CalendarViewDayOutlined as CalendarViewDayOutlinedIcon,
  CalendarMonthOutlined as CalendarMonthOutlinedIcon,
  ViewWeekOutlined as ViewWeekOutlinedIcon,
} from "@mui/icons-material";

class RangeSelect extends React.Component {
  render() {
    const { view, activeCalendar } = this.props.app.state;
    const isCamping = activeCalendar?.type === 'accommodation';
    const activeTextClass = isCamping ? 'text-taborisko-pine' : 'text-splavma-teal';

    const viewOptions = [
      { value: 'month', icon: <CalendarMonthOutlinedIcon fontSize="small" />, label: 'Mesiac' },
      { value: '2weeks', icon: <CalendarViewMonthOutlinedIcon fontSize="small" />, label: '2 týždne' },
      { value: 'week', icon: <CalendarViewWeekOutlinedIcon fontSize="small" />, label: 'Týždeň' },
      { value: '3days', icon: <ViewWeekOutlinedIcon fontSize="small" />, label: '3 dni' },
      { value: '1day', icon: <CalendarViewDayOutlinedIcon fontSize="small" />, label: 'Deň' },
    ];

    return (
      <div className="hidden md:flex items-center gap-1 bg-white/5 rounded-full p-1 backdrop-blur-md border border-white/10">
        {viewOptions.map(option => (
          <button
            key={option.value}
            onClick={() => {
              this.props.app.functions.setViewType(option.value);
              this.props.app.functions.pushHistoryState();
              localStorage.setItem('view', option.value);
            }}
            className={`
              px-4 py-1.5 rounded-full transition-all duration-300 flex items-center gap-2 text-xs font-bold uppercase tracking-wider
              ${view === option.value
                ? `bg-white ${activeTextClass} shadow-lg scale-105`
                : 'text-white hover:bg-white/10'
              }
            `}
            title={option.label}
          >
            {option.icon}
            <span className="hidden xl:inline">{option.label}</span>
          </button>
        ))}
      </div>
    );
  }
}

export default withAllContexts(RangeSelect);
